var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthAndSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5985_13078",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5985_13078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0415 21.8752H18.9582V18.2294H22.604V15.3127H18.9582V11.6669H16.0415V15.3127H12.3957V18.2294H16.0415V21.8752ZM17.4998 30.5691C14.57 29.6996 12.1362 27.9248 10.1983 25.2447C8.26045 22.5645 7.2915 19.5455 7.2915 16.1877V8.30139L17.4998 4.48749L27.7082 8.30139V16.1877C27.7082 19.5455 26.7392 22.5645 24.8013 25.2447C22.8635 27.9248 20.4296 29.6996 17.4998 30.5691ZM17.4998 29.021C20.0276 28.2189 22.1179 26.6148 23.7707 24.2085C25.4234 21.8023 26.2498 19.1287 26.2498 16.1877V9.29707L17.4998 6.04389L8.74984 9.29707V16.1877C8.74984 19.1287 9.57623 21.8023 11.229 24.2085C12.8818 26.6148 14.9721 28.2189 17.4998 29.021Z",
    fill: "#009A50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthAndSafety);
export default __webpack_public_path__ + "static/media/health_and_safety.9104ab70ed40b306ebf05094749510e3.svg";
export { ForwardRef as ReactComponent };